import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ProcessAction } from '../../interfaces/process-action.interface';
import { ProcessEntry } from '../../interfaces/screen-actions.interface';
import { TableConfig } from '../table/interfaces/table-config.interface';
import { floatingActionButtonAnimations } from './floating-action-button.animations';

@Component({
  selector: 'sellions-layout-renderer-floating-action-button',
  templateUrl: './floating-action-button.component.html',
  animations: floatingActionButtonAnimations,
})
export class FloatingActionButtonComponent implements OnChanges {
  @Input() config: TableConfig;
  @Output() clickedButton = new EventEmitter<ProcessAction>();

  mainButtonIcon = 'add';
  fabButtons: ProcessEntry[] = [];
  buttons = [];
  fabTogglerState = 'inactive';

  constructor() {}

  ngOnChanges(): void {
    this.initializeButton();
  }

  showItems() {
    this.fabTogglerState = 'active';
    this.buttons = this.fabButtons;
  }

  hideItems() {
    this.fabTogglerState = 'inactive';
    this.buttons = [];
  }

  onToggleFab() {
    if (this.fabButtons.length === 1) {
      this.onClick(0);
    } else {
      this.buttons.length && this.buttons.length > 0 ? this.hideItems() : this.showItems();
    }
  }

  onClick(index: number) {
    this.clickedButton.emit({process: this.fabButtons[index], element: null});
  }

  private initializeButton() {
    this.fabButtons = this.config.screenActions.processList.filter((process) => !process.contextMenuVisible);
    this.mainButtonIcon = this.config.screenActions.actionListIcon;
  }

  hasAnyItems() {
    return this.config
        && this.config.screenActions
        && this.config.screenActions.processList
        && this.config.screenActions.processList.find(process => !process.contextMenuVisible) != null;
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/floating-action-button/floating-action-button.component.ts